import { Alert, Button, message } from "antd";
import { useEffect, useState } from "react";
import { useAppSelector } from "../../hooks/redux-hooks";
import { membersService } from "../../service/members.service";

// Shown while a subscription payment is failing but Stripe is still retrying
// (before any cancellation). Solo users and group admins get a Fix payment
// button (Stripe hosted invoice / billing portal); group members are asked
// to contact their administrator.
const PaymentFailingBanner = () => {
  const { userInfo } = useAppSelector((state) => state.auth);
  const [dismissed, setDismissed] = useState(false);
  const [loading, setLoading] = useState(false);

  // Re-arm after the failure clears so a NEW failure months later still shows.
  useEffect(() => {
    if (!userInfo.billing_payment_failing) setDismissed(false);
  }, [userInfo.billing_payment_failing]);

  if (!userInfo.billing_payment_failing || dismissed) return null;

  const isAdmin = userInfo.is_group_admin;
  const isGroupMember = Boolean(userInfo.group_name) && !isAdmin;

  const bannerMessage = isGroupMember
    ? "Your team's payment didn't go through. Please contact your admin to fix it."
    : isAdmin
      ? "Your team's payment didn't go through. Please pay now to keep your team's access."
      : "Your payment didn't go through. Please pay now to keep access.";

  const handleFixPayment = async () => {
    setLoading(true);
    // Open the tab synchronously in the click gesture — Safari blocks
    // window.open after an await.
    const payTab = window.open("", "_blank");
    try {
      const { portal_url } = await membersService.openBillingPortal("pay");
      if (payTab) {
        payTab.location.href = portal_url;
      } else {
        window.location.href = portal_url;
      }
    } catch {
      payTab?.close();
      message.error("Couldn't open the billing page. Please try again or contact support@getnudgeai.com.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Alert
      banner
      type="warning"
      closable
      onClose={() => setDismissed(true)}
      message={bannerMessage}
      action={
        isGroupMember ? undefined : (
          <Button size="small" type="primary" loading={loading} onClick={handleFixPayment}>
            Pay now
          </Button>
        )
      }
      style={{ justifyContent: "flex-start", textAlign: "left" }}
    />
  );
};

export default PaymentFailingBanner;
